module.exports = __webpack_public_path__ + "img/pinan.235ff488.png";